import { RecruiterPaymentlistTypes } from "../../ActionTypes/recruiterInvoiceTypes";
import { RecruiterPaymentlistActions, RecruiterPaymentlistState } from "../../types/type";


const initialState: RecruiterPaymentlistState = {
  pending: false,
  recruiterPaymentlist: [],
  error: null,
};

export default (state = initialState, action: RecruiterPaymentlistActions,) => {
  switch (action.type) {
    case RecruiterPaymentlistTypes.FETCH_RECRUITER_PAYMENTLIST_REQUEST:
      return {
        ...state,
        pending: false
      };
      case RecruiterPaymentlistTypes.FETCH_RECRUITER_PAYMENTLIST_SUCCESS:
      return {
        ...state,
        pending: true,
        recruiterPaymentlist: action.payload.recruiterPaymentlist,
        error: null
      };
    case RecruiterPaymentlistTypes.FETCH_RECRUITER_PAYMENTLIST_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error
      };
    default:
      return {
        ...state
      };
  }
};
